import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header.js";
import { Sidebar } from "./Sidebar.js";

export function titleFromPathname(pathname: string): string {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/" || path === "/research-jobs") return "Research Jobs";
  if (path === "/research-jobs/new") return "Neuer Research Job";
  if (path.startsWith("/research-jobs/")) return "Research Job";
  if (path === "/hotels" || path === "/pipeline") return "Pipeline";
  if (path.startsWith("/hotels/") || path.startsWith("/leads/")) {
    return "Lead Detail";
  }
  if (path === "/approvals") return "Approvals";
  if (path === "/chat" || path.startsWith("/chat/")) return "Chat";
  if (path === "/settings") return "Settings";
  return "CaraGo";
}

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  const title = titleFromPathname(pathname);

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="relative flex flex-1 flex-col overflow-x-hidden overflow-y-auto">
        <Header title={title} onMenuClick={() => setSidebarOpen(true)} />
        <main className="grow px-4 py-6 sm:px-6 lg:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
